module.exports = __webpack_public_path__ + "static/media/701Hou.c6977c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/701Hou.png
// module id = 1682
// module chunks = 0 1